import { atom } from 'recoil';

/**
 * Selected Room Recoil Atom
 */
export const SelectedRoomAtom = atom<string>({
  key: 'SelectedRoomAtom',
  default: '',
});
